import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpClient, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { BaseService } from '../services/core/base.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class JwtInterceptorProvider implements HttpInterceptor {

  constructor() {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    let currentUser: any = localStorage.getItem("auth_app_token");

    if (currentUser) {

      let user = JSON.parse(currentUser);

      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${user.value}`
        }
      });
    }

    return next.handle(request);
  }
}
